import { DO_AUTOLOGIN } from 'reducers/actions-types';
import {
    fetchCreditCard,
    fetchReplacementProductPreferences,
    login,
    logout,
    populateFavoriteProducts,
    populateLastPurchasedProducts,
    populateMostPurchasedProducts,
    fetchLatestPurchasedProductsBatch,
    fetchMostPurchasedProductsBatch,
    removeCard,
    setReplacementProductsPreferences,
} from './helpers';


export default Object.freeze({
    login,
    logout,
    fetchCreditCard,
    populateFavoriteProducts,
    populateMostPurchasedProducts,
    populateLastPurchasedProducts,
    fetchMostPurchasedProductsBatch,
    fetchLatestPurchasedProductsBatch,
    fetchReplacementProductPreferences,
    setReplacementProductsPreferences,
    removeCard,
    autologin({ user }) {
        return { type: DO_AUTOLOGIN, user };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/user/actions.js